<template>
  <div class="nav-compoment">
    <!-- <van-sticky> -->
    <van-nav-bar
      :class="['nav', theme]"
      :title="title"
      :border="border"
      :fixed="fixed"
      :left-text="leftText"
      :style="NavBarStyle"
      @click-left="onClickLeft"
    >
      <template v-if="leftArrow" #left>
        <div class="back"></div>
      </template>
      <template #right>
        <slot />
      </template>
    </van-nav-bar>
    <!-- </van-sticky> -->
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '请输入标题'
    },
    leftText: {
      type: String,
      default: ''
    },
    border: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: true
    },
    leftArrow: {
      type: Boolean,
      default: true
    },
    NavBarStyle: {
      type: Object,
      default: () => { }
    },
    theme: {
      type: String,
      default: ''
    }
  },
  methods: {
    onClickLeft () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/variables.scss';

// reset vant-nav-bar style
.nav-compoment {
  .van-nav-bar {
    .van-icon {
      color: $black;
    }
    .van-nav-bar__text {
      color: $black;
    }
    .van-nav-bar__title {
      font-size: 18px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      line-height: 21px;
    }
    .back {
      width: 8.5px;
      height: 15px;
      background-image: url('https://pic.ediangong.com/elec/2023-6-8/4fc5679231de1e5d1a6ad751cee03cb6.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
  }

  .theme_1 {
    background: $transparent;
    .van-nav-bar__text {
      color: #fff;
    }
    .van-nav-bar__title {
      color: #fff;
    }
    .back {
      background-image: url('https://pic.ediangong.com/elec/2023-6-8/5979e30b5fa9e051201bf5d329e86bbf.png');
    }
  }

  .theme_2 {
    background: $transparent;
    .van-nav-bar__text {
      color: #36404b;
    }
    .van-nav-bar__title {
      color: #36404b;
    }
  }
}
</style>
